<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="newProject"
      :class="{
        opened: opened.indexOf('newProject') >= 0,
        'last-active': opened.indexOf('newProject') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div v-if="!dataChanged" class="atom-back atom-back--gray" @click="closeBox('newProject')">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <div v-if="dataChanged" class="atom-back atom-back--gray" @click="toggleConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runSave()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozit") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("novyProjekt") }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.project" class="text-danger">
          {{ errors.project }}
        </div>
        <div v-if="longWaiting" class="text-danger">
          <p class="text-danger">
            {{ $t("tatoOperaceMuzeChviliTrvat") }}
          </p>
        </div>
        <div class="my-4">
          <div class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label text-left">{{ $t("nazevProjektu") }}</span>
            <div
              :class="{
                'has-error': errors.project && !newProject.projectName,
                disabled: false
              }"
              class="side-box__content__input custom-control__custom-input ml-3"
            >
              <span v-if="!newProject.projectName" class="placeholder">{{ $t("zadejteNazevProjektu") }}</span>
              <input
                v-model="newProject.projectName"
                autofocus
                class="w-100"
                maxlength="30"
                minlength="1"
                placeholder=""
                type="text"
              />
            </div>
          </div>
          <div v-if="customers.length > 0">
            <FormSelect
              :items="customers ?? []"
              :label="$t('vyberteZakaznika')"
              :value="selectedCustomer"
              class="mb-3"
              item-text="customerName"
              item-value="customerId"
              side-box
              @change="selectedCustomer = $event"
            />
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleConfirmation"
      @no="closeBox('newProject')"
      @yes="runSave()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal
        :centered="true"
        :errors="errorsToTranslate"
        :opened="openedError"
        @close="
          () => {
            openedError = false
            $emit('closeBox', 'newProject')
          }
        "
      />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import Select from "@/components/inputs/select.vue"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"
import FormSelect from "@/components/forms/FormSelect.vue"

export default {
  components: {
    FormSelect,
    SaveConfirmationModal,
    ErrorModal,
    CustomSelect: Select
  },
  props: {
    opened: Array
  },
  setup() {
    const customerStore = useCustomerStore()
    const projectStore = useProjectStore()

    return { customerStore, projectStore }
  },
  data() {
    return {
      newProject: [],
      errors: {
        project: ""
      },
      openedError: false,
      errorsToTranslate: [],
      openedConfirmation: false,
      selectedCustomer: {},
      longWaiting: false
    }
  },
  computed: {
    customers() {
      return this.customerStore.customerList
    },
    storedProject() {
      return this.projectStore.selectedProject
    },
    storedCustomer() {
      return this.customerStore.selectedCustomer
    },
    dataChanged() {
      if (this.newProject.projectName == "" || this.newProject.projectName == undefined) {
        console.log(this.newProject.projectName)
        return false
      } else {
        console.log(this.newProject.projectName)
        return true
      }
    }
  },
  watch: {
    customers() {
      if (this.storedProject) {
        this.setCustomer()
      }
    },
    storedProject() {
      if (this.customers) {
        this.setCustomer()
      }
    }
  },
  mounted() {
    if (this.customers) {
      this.setCustomer()
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === "newProject") {
        this.$emit("closeBox", box)
      } else {
        this.errors.endpoint = ""
        this.$emit("closeBox", box)
      }
    },
    setCustomer() {
      this.selectedCustomer = this.storedCustomer
    },
    async runSave() {
      if (!this.newProject.projectName && this.selectedCustomer != {}) {
        this.errors.project = this.$t("Vyplňte všechna označená pole.")
      } else {
        this.longWaiting = true
        this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
        this.errorsToTranslate = []
        this.errors.project = ""
        let created = await this.createProject()

        if (created) {
          this.longWaiting = false
          this.$emit("reloadProjects")
          this.$store.commit("modals/setWaitingLoader", "")
          if (this.errorsToTranslate.length > 0) {
            this.openedError = true
          } else {
            this.closeBox("newProject")
          }
        }
      }
    },
    createProject() {
      return axios
        .post(process.env.VUE_APP_API + "/projects/", {
          projectName: this.newProject.projectName,
          customerId: this.selectedCustomer.customerId
        })
        .then((result) => {
          axios
            .get(process.env.VUE_APP_API + "/projects/" + result.data.projectId)
            .then((response) => {
              /*
                this.$store.commit("auth/pushProjects1", {
                project: response.data.data
              });
              */
              this.projectStore.setProject(response.data.data)
            })
            .catch(() => {})
          return true
        })
        .catch((error) => {
          this.errorsToTranslate.push(error.data)
          //this.openedError = true;
          return true
        })
    },
    toggleConfirmation() {
      this.openedConfirmation = this.openedConfirmation ? false : true
    },
    selectCustomer(customer) {
      this.selectedCustomer = customer
    }
  }
}
</script>

<style lang="scss" scoped></style>
